"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _NavMarker = _interopRequireDefault(require("react-rhumb/NavMarker"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _RequestStatusTypes = _interopRequireDefault(require("../constants/RequestStatusTypes"));

var _ReviewInput = _interopRequireDefault(require("../components/ReviewInput"));

var _ReviewModalSuccess = _interopRequireDefault(require("../components/ReviewModalSuccess"));

var _GoodsActions = require("../actions/GoodsActions");

var _auth = require("../selectors/auth");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var ReviewModalContainer = _react.default.createClass({
  displayName: "ReviewModalContainer",
  propTypes: {
    currentUserEmail: _react.PropTypes.string,
    currentUserFullName: _react.PropTypes.string.isRequired,
    goodId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    parentId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    goodName: _react.PropTypes.string.isRequired,
    closeReviewModal: _react.PropTypes.func.isRequired,
    open: _react.PropTypes.bool.isRequired,
    pageOpenedFrom: _react.PropTypes.string.isRequired,
    submitReview: _react.PropTypes.func.isRequired,
    submitReviewStatus: _react.PropTypes.string.isRequired,
    transactionId: _react.PropTypes.number
  },
  render: function render() {
    var _this$props = this.props,
        currentUserEmail = _this$props.currentUserEmail,
        currentUserFullName = _this$props.currentUserFullName,
        goodName = _this$props.goodName,
        goodId = _this$props.goodId,
        open = _this$props.open,
        pageOpenedFrom = _this$props.pageOpenedFrom,
        parentId = _this$props.parentId,
        submitReviewStatus = _this$props.submitReviewStatus,
        transactionId = _this$props.transactionId;

    if (!open || !transactionId) {
      return null;
    }

    if (submitReviewStatus === _RequestStatusTypes.default.SUCCEEDED) {
      return _react.default.createElement(_ReviewModalSuccess.default, {
        closeReviewModal: this.props.closeReviewModal
      });
    }

    return _react.default.createElement(_NavMarker.default, {
      name: "DETAIL_REVIEW_MODAL_LOAD"
    }, _react.default.createElement(_UIModal.default, {
      width: 500,
      className: "integrate-review-modal-input",
      "data-test-id": "review-modal"
    }, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
      onClick: this.props.closeReviewModal
    }), _react.default.createElement(_H.default, {
      className: "m-all-0"
    }, _I18n.default.text('reviewModal.header'))), _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UISection.default, null, _react.default.createElement("p", {
      className: "m-bottom-0"
    }, _react.default.createElement("strong", null, _I18n.default.text('reviewModal.product'))), _react.default.createElement("p", null, goodName)), _react.default.createElement(_ReviewInput.default, {
      currentUserEmail: currentUserEmail,
      currentUserFullName: currentUserFullName,
      goodId: goodId,
      parentId: parentId,
      pageOpenedFrom: pageOpenedFrom,
      submitReview: this.props.submitReview,
      submitReviewStatus: submitReviewStatus,
      transactionId: transactionId
    }))));
  }
});

function mapStateToProps(state) {
  return {
    currentUserEmail: (0, _auth.getCurrentUserEmail)(state),
    currentUserFullName: (0, _auth.getCurrentUserFullName)(state),
    goodId: state.reviewInputInfo.get('goodId'),
    goodName: state.reviewInputInfo.get('goodName'),
    open: state.reviewInputInfo.get('open'),
    parentId: state.reviewInputInfo.get('parentId'),
    submitReviewStatus: state.reviewInputInfo.get('submitReviewStatus'),
    transactionId: state.reviewInputInfo.get('transactionId')
  };
}

var mapDispatchToProps = {
  closeReviewModal: _GoodsActions.closeReviewModal,
  submitReview: _GoodsActions.submitReview
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReviewModalContainer);

exports.default = _default;
module.exports = exports.default;